module.exports = __webpack_public_path__ + "media/Tiger.d783c784.mp3";